(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // GSAP ScrollTrigger Integration for Hide/Show & Blur Effect
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.create({
          start: 'top top',
          end: 'max',
          onUpdate: (self) => {
            if (self.scroll() > 50) {
              this.header.classList.add('is-scrolled');
            } else {
              this.header.classList.remove('is-scrolled');
            }
          }
        });

        // Hide header on scroll down, reveal smoothly on scroll up
        let lastScroll = 0;
        ScrollTrigger.create({
          start: 'top top',
          end: 'max',
          onUpdate: (self) => {
            const currentScroll = self.scroll();
            if (currentScroll > lastScroll && currentScroll > 150) {
              // Scrolling Down - Hide Header smoothly
              gsap.to(this.header, { yPercent: -100, duration: 0.3, ease: 'power2.out' });
            } else {
              // Scrolling Up - Reveal Header smoothly
              gsap.to(this.header, { yPercent: 0, duration: 0.3, ease: 'power2.out' });
            }
            lastScroll = currentScroll;
          }
        });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
